<template>
  <div>
    <div class="header">
      <Desktop v-if="!mobile" :menu="menu" />
      <Mobile v-else :menu="menu" />
    </div>
  </div>
</template>

<script>
import Desktop from "./Desktop.vue";
import Mobile from "./Mobile.vue";
import { getMenu } from "../../../config";

export default {
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    productsCategories() {
      return this.$rest("products-categories").list;
    },
    menu() {
      return getMenu(this);
    },
  },
  components: {
    Desktop,
    Mobile,
  },
};
</script>

<style scoped>
.header {
  position: relative;
  z-index: 630;
}

@media screen and (max-width: 1264px) {
  .page-title {
    margin-top: 64px;
  }

  .header {
    z-index: 99999 !important;
  }
}

@media screen and (max-width: 960px) {
  .page-title {
    margin-top: 56px;
  }
}
</style>
